<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
    #sidenav
  >
    <div class="side-nave">
      <div class="navigation-header">
        <a routerLink="/" style="cursor: pointer; max-width: 240px; max-height: 80px">
          <div class="logo"></div>
        </a>
        @if (isAuthenticated$ | async) {
          @if (currentUser$ | async; as user) {
            <div class="profile" matBadge="4" matBadgeSize="large">
              <h1>{{ user.given_name[0] }}{{ user.family_name[0] }}</h1>
            </div>
            <h2 class="username">{{ user.given_name }} {{ user.family_name }}</h2>
            <p class="email-adress">{{ user.email }}</p>
          }
        }
      </div>
      <mat-nav-list class="dark">
        @for (item of visibleRoutes$ | async; track item.path) {
          <a
            mat-list-item
            [routerLink]="item.path"
            #link="routerLinkActive"
            routerLinkActive
            [activated]="link.isActive"
          >
            <div class="nav-item-icon">
              <mat-icon>{{ item.icon }}</mat-icon>
              <span class="nav-item-text">{{ item.title }}</span>
            </div>
          </a>
        }
      </mat-nav-list>
      <div class="navigation-footer dark">
        <button
          mat-icon-button
          aria-label="Example icon button with a vertical three dot icon"
          matBadge="4"
          matBadgeSize="large"
        >
          <mat-icon>notifications</mat-icon>
        </button>
        <button
          mat-icon-button
          aria-label="Example icon button with a open in new tab icon"
          [matMenuTriggerFor]="language"
        >
          <mat-icon>language</mat-icon>
        </button>
        <mat-menu #language="matMenu">
          <button mat-menu-item>Englisch</button>
          <button mat-menu-item>Deustch</button>
        </mat-menu>
        @if (isAuthenticated$ | async) {
          <button
            mat-icon-button
            aria-label="Example icon button with a open in new tab icon"
            [matMenuTriggerFor]="userMenu"
          >
            <mat-icon>account_circle</mat-icon>
          </button>
          <mat-menu #userMenu="matMenu">
            <button mat-menu-item (click)="logout()">
              <mat-icon>logout</mat-icon>
              <span>Abmelden</span>
            </button>
          </mat-menu>
        }
        <div class="legals-link">
          <button mat-button routerLinkActive>impressum</button>
          <div>
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item>Unser Produkt</button>
              <button mat-menu-item>AGB's</button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="content">
      <mat-card appearance="outlined">
        <mat-card-content>
          <div class="health-status-wrapper">
            <app-health-indicator [routerLink]="['/system-health']"></app-health-indicator>
          </div>
          <router-outlet></router-outlet>
          <app-http-transaction-loading></app-http-transaction-loading>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
